import React from 'react';
import { Button } from './ui/button';
import { Globe, Sun, Moon } from 'lucide-react';

export const Navbar = ({ currentLang, setCurrentLang, translations, isDark, setIsDark }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const toggleLanguage = () => {
    setCurrentLang(currentLang === 'pl' ? 'en' : 'pl');
  };

  const toggleTheme = () => {
    setIsDark(!isDark);
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 backdrop-blur-md border-b transition-colors duration-300 ${
      isDark 
        ? 'bg-zinc-950/90 border-zinc-800' 
        : 'bg-white/90 border-zinc-200'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className={`w-8 h-8 flex items-center justify-center ${isDark ? 'bg-cyan-400' : 'bg-cyan-500'}`}>
              <span className={`font-bold text-xl ${isDark ? 'text-black' : 'text-white'}`}>A</span>
            </div>
            <span className={`font-bold text-xl tracking-tight ${isDark ? 'text-white' : 'text-zinc-900'}`}>AS COM</span>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`transition-colors duration-200 text-sm uppercase tracking-wider ${
                isDark ? 'text-zinc-400 hover:text-cyan-400' : 'text-zinc-600 hover:text-cyan-600'
              }`}
            >
              {translations.nav.home}
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`transition-colors duration-200 text-sm uppercase tracking-wider ${
                isDark ? 'text-zinc-400 hover:text-cyan-400' : 'text-zinc-600 hover:text-cyan-600'
              }`}
            >
              {translations.nav.services}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`transition-colors duration-200 text-sm uppercase tracking-wider ${
                isDark ? 'text-zinc-400 hover:text-cyan-400' : 'text-zinc-600 hover:text-cyan-600'
              }`}
            >
              {translations.nav.about}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`transition-colors duration-200 text-sm uppercase tracking-wider ${
                isDark ? 'text-zinc-400 hover:text-cyan-400' : 'text-zinc-600 hover:text-cyan-600'
              }`}
            >
              {translations.nav.portfolio}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`transition-colors duration-200 text-sm uppercase tracking-wider ${
                isDark ? 'text-zinc-400 hover:text-cyan-400' : 'text-zinc-600 hover:text-cyan-600'
              }`}
            >
              {translations.nav.contact}
            </button>
          </div>

          <div className="flex items-center space-x-3">
            <Button
              onClick={toggleTheme}
              variant="outline"
              size="sm"
              className={`transition-all duration-200 ${
                isDark 
                  ? 'bg-transparent border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black'
                  : 'bg-transparent border-cyan-500 text-cyan-600 hover:bg-cyan-500 hover:text-white'
              }`}
            >
              {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </Button>
            <Button
              onClick={toggleLanguage}
              variant="outline"
              size="sm"
              className={`transition-all duration-200 ${
                isDark 
                  ? 'bg-transparent border-cyan-400 text-cyan-400 hover:bg-cyan-400 hover:text-black'
                  : 'bg-transparent border-cyan-500 text-cyan-600 hover:bg-cyan-500 hover:text-white'
              }`}
            >
              <Globe className="w-4 h-4 mr-2" />
              {currentLang === 'pl' ? 'EN' : 'PL'}
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};